<template>
	<div style='width:100%'>
		<item-component :items='items'></item-component>
		<div v-if='category.count > 4' class='items_group_more' @click='onSelectCategory(category.data.id,category_index)'>
			еще {{category.count - 4}}...
		</div>
	</div>
</template>

<script>
	import ItemComponent from './ItemComponent.vue'

	export default {
		name: "CellComponent",
		props: ['items', 'category', 'onSelectCategory', 'category_index'],
		components: {ItemComponent},
	}
</script>

<style scoped lang='scss'>
	.items
	{
		&_group
		{
			&_more
			{
				color: rgba(100, 119, 136, .7);
				cursor: pointer;
			}

		}
	}
</style>